var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsumerGym(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2516_56339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0106 9.95361H7.98828V12.0496H14.0106V9.95361Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.92871 9.36367V9.57657C3.8499 9.5284 3.76352 9.49544 3.66587 9.49544C3.37655 9.49544 3.14258 9.72979 3.14258 10.0186V11.9838C3.14258 12.2726 3.37655 12.507 3.66587 12.507C3.76352 12.507 3.8499 12.474 3.92871 12.4258V12.6387C3.92871 13.1725 4.32903 13.608 4.84515 13.6728V8.32959C4.32903 8.39443 3.92871 8.82988 3.92871 9.36367Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3335 9.49544C18.2358 9.49544 18.1495 9.5284 18.0707 9.57657V9.36367C18.0707 8.82988 17.6703 8.39443 17.1543 8.32959V13.673C17.6704 13.608 18.0707 13.1727 18.0707 12.6389V12.426C18.1495 12.4742 18.2359 12.5071 18.3335 12.5071C18.6228 12.5071 18.8568 12.2728 18.8568 11.9839V10.0188C18.8568 9.72979 18.6228 9.49544 18.3335 9.49544Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41634 6.68115C5.8384 6.68115 5.36914 7.15041 5.36914 7.72905V14.2737C5.36914 14.8523 5.83847 15.3216 6.41634 15.3216C6.99498 15.3216 7.46431 14.8523 7.46431 14.2737V7.72905C7.46431 7.15041 6.99498 6.68115 6.41634 6.68115Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5831 6.68115C15.0045 6.68115 14.5352 7.15041 14.5352 7.72905V14.2737C14.5352 14.8523 15.0045 15.3216 15.5831 15.3216C16.1611 15.3216 16.6303 14.8523 16.6303 14.2737V7.72905C16.6303 7.15041 16.1611 6.68115 15.5831 6.68115Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11.0015,
    r: 10.75,
    stroke: "black",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2516_56339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0 0.00146484)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumerGym);
export default __webpack_public_path__ + "static/media/consumer_gym.eadc339f83ce1e75ac8f3d07ba6a4c3b.svg";
export { ForwardRef as ReactComponent };